<template>
  <div id="AgreementList" class="flex-content">
    <nav-bar class="nav_fixed" :isExam="true" :backPath="backIndex">
      <i slot="left-icon" class="icon-back public_icon"></i>
      <div slot="center">协议记录</div>
    </nav-bar>

    <div class="paddingtb_nav">
      <div
        class="agreement_item paddinglr white_bg bordertb"
        v-for="item in agreementList"
        :key="item.id"
      >
        <p class="agreement_title flex justify-between">
          <!--标题组成：类别+层次+报名协议-->
          <span class="title"
            >{{
              item.areaLocationName.includes("校区")
                ? item.areaLocationName
                : `${item.areaLocationName}校区`
            }}-{{ item.floorNumber }}楼-{{ item.number }}室</span
          >
          <span :class="item.status == 4 ? 'inlineblock2' : 'inlineblock1'">{{
            item.stateStr
          }}</span>
        </p>
        <dl>
          <dd>创建时间：{{ item.createTime | Timefilters }}</dd>
          <dd v-if="item.status == 1 || item.status == 3"></dd>
          <dd v-else>
            签订时间：<b
              :class="{ gray: item.signingTime == null || item.signingTime == '' }"
              >{{ item.signingTime | Timefilters }}</b
            >
          </dd>
          <!-- <dd>签订老师：<span :class="item.adminName?'':'gray'">{{ item.adminName || '未设置' }}</span></dd> -->
        </dl>
        <p class="agreement_bottom">
          <span class="btn-left inlineblock" @click="toUrl(item)">
            <i class="agreement_icon"></i>
            查看协议pdf
          </span>
          <router-link
            class="btn-sign gradual_tb"
            :to="{
              name: 'Sign',
              path: '/AgreementRecord/sign',
              query: { id: item.id, isCheckIdCard: item.isCheckIdCard, wordPath: item },
            }"
            v-if="item.status === 1"
            >马上签订租赁协议>>></router-link
          >
          <!-- <button class="btn-sign" v-else>去签订</button> -->
        </p>
      </div>
    </div>

    <nodata :nodata="nodata" v-show="isNodata"></nodata>
    <Foot class="Foot"></Foot>
  </div>
</template>
<script>
import Foot from "../../components/Foot.vue";
import NavBar from "components/common/NavBar";
import Nodata from "components/content/nodata/Nodata";
import { isNull } from "common/utils";
import { GetMyAgreementRerords } from "network/agreementRecord";

export default {
  name: "AgreementList",
  components: {
    NavBar,
    Nodata,
    Foot,
  },
  data() {
    return {
      isNodata: false,
      reletId: 0,
      backIndex: "/index",
      nodata: {
        imgpath: require("../../assets/images/nodata.png"),
        text: "暂无协议记录",
      },
      agreementList: [],
    };
  },
  filters: {
    //时间过滤器
    Timefilters(val) {
      if (val == null || val == "") {
        return "暂无时间";
      } else {
        if (val.indexOf("-") > -1) {
          val = val.replace(/-/g, "/");
        }
        let d = new Date(val); //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times =
          d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
        return times;
      }
    },
  },
  created() {
    this.getPage();
  },

  computed: {
    // isNodata() {
    //   return isNull(this.agreementList);
    // },
  },
  mounted() {
    // 房屋续租页跳转
    this.reletId = this.$route.params.id
    console.log(this.reletId,7878787777);
    if(this.reletId){
      this.backIndex = '/housingRelet'
    }
  },
  methods: {
    //获取数据
    async getPage() {
      this.$loading.show("加载中…");
      let result = "";

      result = await GetMyAgreementRerords();

      console.log(result.result);
      if (result.code === 1) {
        this.agreementList = result.result;
        console.log(result);
        this.$loading.hide();
        if (isNull(this.agreementList)) {
          this.$loading.hide();
          this.isLoading = false;
          this.isNodata = true;
        }
      } else {
        this.$loading.hide();
        this.isLoading = false;
        this.isNodata = true;
        this.$confirm.show(result.message);
      }
    },
    toUrl(item) {
      console.log(item);
      var u = navigator.userAgent;
      console.log(u);
      if (u.indexOf("Android") > -1) {
        this.$router.push({
          path: "/AgreementRecord/detailPDF",
          query: {
            id: item.id,
            Path: item.pdfPath,
            title: `${
              item.areaLocationName.includes("校区")
                ? item.areaLocationName
                : `${item.areaLocationName}校区`
            }-${item.floorNumber}楼-${item.number}室`,
            back: "/AgreementRecord",
          },
        });
      } else {
        // this.$router.push({
        //   path: "/agreement/detailPDF",
        //   query: {
        //     id: item.id,
        //     Path: item.path,
        //     title: item.productName,
        //   },
        // });
        window.open(item.pdfPath);
      }
    },
  },
};
</script>
<style scoped>
#AgreementList {
  position: relative;
  /* height: 100%; */
  z-index: 11;
}
.agreement-wrapper {
  height: calc(100% - 98px);
  overflow: hidden;
}
.agreement_item {
  margin-bottom: 18px;
  font-size: 28px;
  margin: 30px;
  border-radius: 10px;
}
.agreement_item dl {
  font-size: 28px;
  margin-bottom: 34px;
}
.agreement_item dl dd {
  line-height: 44px;
}
.agreement_title {
  line-height: 100px;
  height: 100px;
}

.agreement_title .title {
  font-weight: 600;
}
.agreement_title .inlineblock {
  font-size: 24px;
  line-height: 45px;
  /* border: 1px solid #aaa; */
  /* border-radius: 50px; */
  /* padding: 0 14px; */
  position: absolute;
  right: 24px;
  text-align: center;
  height: 45px;
  width: 100px;
  margin-top: 28px;
  color: #fff;
  /* background: url("../../assets/images/agreement_red.png") no-repeat center; */
  background-color: #34c7fa;
  border-top-left-radius: 35px;
  border-bottom-left-radius: 35px;
  background-size: 100% 100%;
}
.agreement_title .inlineblock::before {
  position: absolute;
  right: 0;
  bottom: -8px;
  content: "";
  background-color: #09a7e8;
  width: 8px;
  height: 8px;
  border-bottom-right-radius: 4px;
}

.agreement_title .inlineblock1 {
  font-size: 24px;
  line-height: 45px;
  /* border: 1px solid #aaa; */
  /* border-radius: 50px; */
  /* padding: 0 14px; */
  position: absolute;
  right: 24px;
  text-align: center;
  height: 50px;
  width: 100px;
  margin-top: 28px;
  color: #fff;
  background: url("../../assets/images/agreement_red.png") no-repeat center;
  background-size: 100% 100%;
}
.agreement_title .inlineblock2 {
  font-size: 24px;
  line-height: 45px;
  /* border: 1px solid #aaa; */
  /* border-radius: 50px; */
  /* padding: 0 14px; */
  position: absolute;
  right: 24px;
  text-align: center;
  height: 50px;
  width: 100px;
  margin-top: 28px;
  color: #fff;
  background: url("../../assets/images/agreement_blue.png") no-repeat center;
  background-size: 100% 100%;
}
.agreement_title .inlineblock3 {
  font-size: 24px;
  line-height: 45px;
  /* border: 1px solid #aaa; */
  /* border-radius: 50px; */
  /* padding: 0 14px; */
  position: absolute;
  right: 24px;
  text-align: center;
  height: 50px;
  /* width: 100px; */
  padding: 0 15px;
  width: auto;
  margin-top: 28px;
  color: #fff;
  background: url("../../assets/images/agreement_red.png") no-repeat center;
  background-size: 100% 100%;
}
.agreement_bottom {
  border-top: 1px solid #eee;
  padding: 20px 0;
  overflow: hidden;
  margin: 0;
}
.btn-left {
  line-height: 60px;
  margin: 0;
}
.agreement_icon {
  width: 54px;
  height: 44px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  background: url("../../assets/images/pdfimg.png") no-repeat center;
}
.btn-sign {
  float: right;
  width: 300px;
  text-align: center;
  border-radius: 60px;
  /* height: 60px; */
  line-height: 60px;
  color: #666;
  font-size: 24px;
}
.btn-sign.gradual_tb {
  color: #fff;
}
.gray {
  color: #999;
}
.flex-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>
